import IconButton from "components/Button/IconButton";
import { dataEmpty } from "components/CommonLib/CommonLib";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import Label from "components/LabelInput/Label";
import TextField from "components/LabelInput/TextField";
import { useEffect, useState } from "react";

const PeriodSalesCntTable = ({ reportState }) => {
  const resultTableInst = new resultTable();
  const [totalCnt, setTotalCnt] = useState(0);

  useEffect(() => {
    const sum =
      reportState.mbshp_period_month.length > 0
        ? reportState.mbshp_period_month[0].month_type_1 +
          reportState.mbshp_period_month[0].month_type_2 +
          reportState.mbshp_period_month[0].month_type_3 +
          reportState.mbshp_period_month[0].month_type_4
        : 0;
    setTotalCnt(sum);
  }, [reportState]);

  return (
    <div style={{}}>
      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
        <IconButton type="border" />
        <Label labelText="유효기간별 판매 수량" marginLeft="0.5rem" fontWeight="bold" />
      </div>
      <CustomTable
        columns_head={resultTableInst.columns_head}
        table_title={resultTableInst.table_title}
        rest_call={resultTableInst.get_data_from_rest}
        row_render={resultTableInst.create_table}
        rest_data={reportState.mbshp_period_month}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.5rem" }}>
        <TextField
          labelText="합계"
          labelWidth="3rem"
          textBoxWidth="10rem"
          textMarginRight="0rem"
          isNumber
          defaultValue={totalCnt.toLocaleString()}
          endAdornment={"건"}
          disabled
        />
      </div>
    </div>
  );
};
export default PeriodSalesCntTable;

class resultTable {
  table_title = "";

  // constructor() {}

  create_table = (data, idx) => {
    return (
      <CustomRow style={{}} key={idx}>
        <CustomTableContents $bgColor="#dfebf3">판매 수량</CustomTableContents>
        <CustomTableContents $isNumber>{data.month_type_1}</CustomTableContents>
        <CustomTableContents $isNumber>{data.month_type_2}</CustomTableContents>
        <CustomTableContents $isNumber>{data.month_type_3}</CustomTableContents>
        <CustomTableContents $isNumber>{data.month_type_4}</CustomTableContents>
      </CustomRow>
    );
  };

  columns_head = [
    { title: "구분", width: "16.66%" },
    { title: "1개월", width: "16.66%" },
    { title: "2~4개월", width: "16.66%" },
    { title: "5~9개월", width: "16.66%" },
    { title: "10개월 이상", width: "16.66%" },
  ];

  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      stateData = [];
    }
    return stateData;
  };
}
